function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M22 11a6.52 6.52 0 1 0 6.52 6.52A6.53 6.53 0 0 0 22 11z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M41 22a19 19 0 1 0-27.74 16.85A16.72 16.72 0 0 0 22 41a16.72 16.72 0 0 0 8.74-2.15A19 19 0 0 0 41 22zm-7.14 12.6v-.39A8.84 8.84 0 0 0 25 25.37h-6a8.84 8.84 0 0 0-8.83 8.84v.39a17.33 17.33 0 1 1 23.72 0z"
});

var SvgComponent = function SvgComponent(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      id: "Layer_1",
      "data-name": "Layer 1",
      viewBox: "0 0 44 44"
    }, props), _ref, _ref2, _ref3)
  );
};

export default SvgComponent;